import axios from "axios";

export const changeExchangeApi = async (credintial, lang, cookies) => {
  const token = cookies.__t0ken_amar_management;

  let data = JSON.stringify({
    dinar: credintial.dinar,
    RMB: credintial.RMB,
  });

  let config = {
    method: "post",
    url: `${process.env.REACT_APP_API}/exchange-rates`,
    headers: {
      lan: lang,
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    data: data,
    timeout: 15000,
  };

  try {
    const res = await axios(config);
    return { success: res.data.success, res: res };
  } catch (error) {
    return { success: false, res: error };
  }
};
